import { createSlice } from '@reduxjs/toolkit';
import {
    entorno,
} from '../actions/entorno';


export const EntornoReducer = createSlice({
    name: 'entorno',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(entorno.pending, (state) => { state.loading = true })
            .addCase(entorno.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(entorno.rejected, (state) => { state.loading = false })
    }
})

export default EntornoReducer.reducer;

